// extracted by mini-css-extract-plugin
module.exports = {"lojaWrapper":"styles_lojaWrapper__wtEBh"};